import Cookies from 'js-cookie';

/* global ga */

export default class Navigation {

  constructor() {
    // general events
    $('.burger').click( () => {

      if ( $('.burger__icon').hasClass('is-open') ) {
        this.closeNav();
      } else {
        this.openNav();
      }

    });

    $(window).scroll( () => this.scroll() );

  }

  openNav() {
    console.log('MENU_OPEN');
    $('.burger__icon').addClass('is-open');
    $('nav.menu').addClass('is-open');
    $('nav.menu').css('visibility', 'visible');
    $('.siteContainer').addClass('is-behindMenu');
    $(document).trigger('MENU_OPEN');

    if ( $('.nlSignup').hasClass('is-active') ) {
      $('.nlSignup').removeClass('is-active');
      $('.menuContainer, .siteContainer, .navButtonsBG').removeClass('is-pushedDown');
      Cookies.set('show_nlsignup', '1', { expires: 30 });
      ga('send', 'event', 'NL Signup Close', 'menu open');
    }
  }

  closeNav( isChanging = false ) {
    console.log('MENU_CLOSED');
    $('.burger__icon').removeClass('is-open');
    $('nav.menu').removeClass('is-open');
    $('.siteContainer').removeClass('is-behindMenu');
    $(document).trigger('MENU_CLOSED');

    setTimeout( () => {
      $('nav.menu').css('visibility', '');
    }, 500);

  }

  scroll() {
    if ( $(window).scrollTop() > 0 && !$('.navButtonsBG').hasClass('is-minimized') ) {
      $('.menuSystem').addClass('is-minimized');
    } else if ( $(window).scrollTop() <= 0 && $('.navButtonsBG').hasClass('is-minimized') ) {
      $('.menuSystem').removeClass('is-minimized');
    }
  }

}



// WEBPACK FOOTER //
// ./js/modules/Navigation.js